<!-- <app-header></app-header>
<div class="app-container">
  <router-outlet></router-outlet>
</div
<app-footer></app-footer> -->
<div style="background-color: rgba(255, 255, 255, 1); position: relative">
  <app-new-header></app-new-header>
  <!-- <div class="halo-wrapper">
    <om-halo
      [animate]="true"
      [interactive]="true"
      position="center"
      [haloSize]="'300px'"
      haloColors="#5fffda 20%, #46a8ff 50%, #cc32f6 100%"
      [haloShadowColors]="[
        'rgba(234, 255, 95, 0.8)',
        'rgba(244, 173, 108, 0.5)',
        'rgba(225, 71, 181, 0.6)'
      ]"
    >
    </om-halo>
  </div> -->
  <!-- <div class="top-left-circle"></div> -->
  <!-- <app-job-header></app-job-header> -->
  <div class="app-container">
    <div [@fadeAnimation]="animationState">
      <router-outlet></router-outlet>
    </div>
    <!-- <router-outlet #outlet="outlet"></router-outlet> -->
  </div>

  <app-body style="background-color: white"></app-body>
  <app-new-footer
    style="background-color: rgba(242, 247, 255, 1)"
  ></app-new-footer>
</div>
